"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Bundle_Search = exports.Bundle_SearchModeKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_decimal_1 = require("../Scalar/RTTI_decimal");
var Bundle_SearchModeKind;
(function (Bundle_SearchModeKind) {
    Bundle_SearchModeKind["_match"] = "match";
    Bundle_SearchModeKind["_include"] = "include";
    Bundle_SearchModeKind["_outcome"] = "outcome";
})(Bundle_SearchModeKind = exports.Bundle_SearchModeKind || (exports.Bundle_SearchModeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_Bundle_Search = t.recursion('IBundle_Search', function () {
    return t.partial({
        id: t.string,
        extension: t.array(RTTI_Extension_1.RTTI_Extension),
        modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
        mode: (0, EnumType_1.createEnumType)(Bundle_SearchModeKind, 'Bundle_SearchModeKind'),
        _mode: RTTI_Element_1.RTTI_Element,
        score: RTTI_decimal_1.RTTI_decimal,
        _score: RTTI_Element_1.RTTI_Element
    });
});
//# sourceMappingURL=RTTI_Bundle_Search.js.map